import { ApiService } from '@b2b/common/services/api/types';
import { PermissionsService } from '@b2b/common/services/permissions';
import { TODO } from '@b2b/types/core';
import { StateService } from '@uirouter/angularjs';
import angular, { IScope } from 'angular';

export const MembershipRulesLifecycleModule = angular
  .module('acme.view.application.membership.rules.lifecycle.controllers', [
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.permissions',
  ])

  .controller('MembershipRulesLifecycleController', [
    '$scope',
    '$state',
    'ApiService',
    'HelpersService',
    'PermissionsService',
    'MembershipLifecycleActionFormListData',
    function (
      $scope: IScope & { membershipRulesLifecycle: TODO },
      $state: StateService,
      ApiService: ApiService,
      HelpersService: TODO,
      PermissionsService: PermissionsService,
      MembershipLifecycleActionFormListData: TODO
    ) {
      const ctrl = {
        model: [],
        isLoaded: false,
        isSaving: false,
        membershipLifeCycleDiscounts: {},
        membershipLifecycleForms: {},
        excludedCategoriesForCouponDiscounts: [
          'STANDARD_DOWNGRADE',
          'EARLY_TERM_DOWNGRADE',
          'MID_TERM_DOWNGRADE',
          'LATE_TERM_DOWNGRADE',
          'STANDARD_CANCELLATION',
          'EARLY_TERM_CANCELLATION',
          'LATE_TERM_CANCELLATION',
        ],

        includedCategoriesForForms: [
          'STANDARD_NEW',
          'STANDARD_RENEW',
          'UPGRADE_RENEW',
          'DOWNGRADE_RENEW',
          'STANDARD_UPGRADE',
          'STANDARD_DOWNGRADE',
          'AFTER_TERM_RENEW',
          'AFTER_TERM_UPGRADE',
          'AFTER_TERM_DOWNGRADE',
          'REJOIN_RENEW',
          'REJOIN_UPGRADE',
          'REJOIN_DOWNGRADE',
        ],

        init: function () {
          $scope.$emit('Application::contentTitleChange', {
            title: 'Membership Lifecycle Rules',
          });

          ctrl.getCouponDiscounts();

          if (MembershipLifecycleActionFormListData && MembershipLifecycleActionFormListData.data.success) {
            this.membershipLifecycleForms = this.process(MembershipLifecycleActionFormListData.data.payload.list);
          }
        },

        seed: function () {
          ctrl.isLoaded = false;
          ApiService.rulesEngine.lifecycle.init().then(function (response) {
            ctrl.getLifecycleRules();
          });
        },

        getCouponDiscounts: function () {
          var props;

          if (PermissionsService.check('MEMBERSHIP_LIFECYCLE_ACTION_DISCOUNT_VIEW')) {
            props = HelpersService.getPaginator();
            ApiService.membership.lifecycle.discounts.list(props).then(ctrl.success.init, ctrl.error.init);
          }
        },

        getLifecycleRules: function () {
          ApiService.rulesEngine.lifecycle.list().then(ctrl.success.getLifecycleRules, ctrl.error.getLifecycleRules);
        },

        findAction: function (actions, id) {
          let r: TODO = false;

          for (let i = 0, ii = actions.length; i < ii; i++) {
            if (actions[i].id === id) {
              r = {
                index: i,
                action: actions[i],
              };
              break;
            }
          }

          return r;
        },

        changeRule: function (rule) {
          rule.lastSelectedId = rule.selectedId;
          rule.edit = true;
        },

        cancelRule: function (rule) {
          rule.selectedId = rule.lastSelectedId;

          rule.lastSelectedId = null;
          delete rule.lastSelectedId;

          rule.edit = false;
        },

        saveRule: function (category, rule) {
          rule.lastSelectedId = null;
          delete rule.lastSelectedId;

          ctrl.isSaving = true;

          ApiService.rulesEngine.rule.update({ category: category, rule: rule }).then(function (response) {
            var self = $scope.membershipRulesLifecycle;

            rule.edit = false;
            self.success.saveRule(response);
          }, ctrl.error.saveRule);
        },

        viewCouponDiscounts: function (category) {
          $state.go('application.membership.pricing.discounts', { action: category });
        },

        viewForms: function(category) {
          $state.go('application.membership.forms', { action: category });
        },

        isCouponDiscountsSupported: function (category) {
          return (
            category.category && ctrl.excludedCategoriesForCouponDiscounts.indexOf(category.category.toUpperCase()) < 0
          );
        },

        isFormsSupported: function (category) {
          return (
            category.category && ctrl.includedCategoriesForForms.indexOf(category.category.toUpperCase()) >= 0
          );
        },

        process: function (list) {
          var i,
            ii,
            membershipLifeCycleDiscounts = {},
            lifeCycleAction;

          for (i = 0, ii = list.length; i < ii; i++) {
            lifeCycleAction = list[i].lifecycleAction;
            if (membershipLifeCycleDiscounts.hasOwnProperty(lifeCycleAction)) {
              membershipLifeCycleDiscounts[lifeCycleAction] = membershipLifeCycleDiscounts[lifeCycleAction] + 1;
            } else {
              membershipLifeCycleDiscounts[lifeCycleAction] = 1;
            }
          }
          return membershipLifeCycleDiscounts;
        },

        success: {
          init: function (response) {
            ctrl.membershipLifeCycleDiscounts = ctrl.process(response.data.payload.list);
            ctrl.isLoaded = true;
            ctrl.getLifecycleRules();
          },
          saveRule: function (response) {
            ctrl.isSaving = false;
          },
          getLifecycleRules: function (response) {
            ctrl.isLoaded = true;
            ctrl.model = response.data.payload;
          },
        },

        error: {
          init: function (response) {
            ctrl.isLoaded = true;
            ctrl.getLifecycleRules();
          },
          saveRule: function (response) {
            ctrl.isSaving = false;
          },
          getLifecycleRules: function (response) {
            ctrl.isLoaded = true;
          },
        },
      };

      $scope.membershipRulesLifecycle = ctrl;
      ctrl.init();
    },
  ]).name;
